module.exports = __webpack_public_path__ + "static/img/clipboard.a754c187.svg";